import { render, staticRenderFns } from "./YinHuaShui.vue?vue&type=template&id=50045de8&scoped=true"
import script from "./YinHuaShui.vue?vue&type=script&lang=js"
export * from "./YinHuaShui.vue?vue&type=script&lang=js"
import style0 from "./YinHuaShui.vue?vue&type=style&index=0&id=50045de8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50045de8",
  null
  
)

export default component.exports